import React from 'react';
import OrderPreparationStatusStatuses from "../OrderPreparationStatusStatuses";
import OrderPreparationStatusInfo from "../OrderPreparationStatusInfo";
import {ConfigApi, OrderApi, OrderTrackingStatus} from "../../../../../services/Api/types";

const Map = React.lazy(() => import('./OrderPreparationStatusDeliveryMap'));

interface Props {
    order: OrderApi;
    orderTrackingStatus: OrderTrackingStatus;
    onUpdate: (order: OrderApi) => void;
    config: ConfigApi;
}

const OrderDeliveryPreparationStatusComponent = ({order, orderTrackingStatus, onUpdate, config}: Props) => {
    return (
        <div>
            <OrderPreparationStatusStatuses order={order} orderTrackingStatus={orderTrackingStatus}/>
            <Map order={order} config={config} orderTrackingStatus={orderTrackingStatus}/>
            <OrderPreparationStatusInfo order={order} orderTrackingStatus={orderTrackingStatus} onUpdate={onUpdate}
                                        config={config}/>
        </div>
    )
}

export default OrderDeliveryPreparationStatusComponent;